import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { CreationToolSourceFile } from '../../../types'
import { SourceEditorCaption, SourceEditorCrop, SourceEditorEdits, SourceEditorTimeline } from '../types'

type Props = {
    source: CreationToolSourceFile
    timeline: SourceEditorTimeline
    captions: SourceEditorCaption[]
    crop: SourceEditorCrop
}

export function useEdits({ source, timeline, captions, crop }: Props): SourceEditorEdits | undefined {
    const [edits, setEdits] = useState<SourceEditorEdits | undefined>()

    useEffect(() => {
        const filteredCaptions = captions.filter(({ text }) => !!text)
        const isTrimmed = timeline.start > 0 || timeline.end < source.duration
        const isCropped = crop.width < source.width || crop.height < source.height
        const cleanedEdits: SourceEditorEdits = {}

        // captions
        if (filteredCaptions.length) {
            cleanedEdits.captions = filteredCaptions
        }

        // trim
        if (isTrimmed) {
            cleanedEdits.trim = { ...timeline }
        }

        // crop
        if (isCropped) {
            cleanedEdits.crop = { ...crop }
        }

        setEdits(isEmpty(cleanedEdits) ? undefined : cleanedEdits)
    }, [source, timeline, captions, crop])

    return edits
}
